module.exports = __webpack_public_path__ + "static/media/classic_beauty_5.2a65c21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/classic_beauty_5.jpg
// module id = 514
// module chunks = 0